export function extractV2PromotionsList(response) {
  if (!response || response.status !== 200) {
    return null;
  }

  const body = response.data;

  if (Array.isArray(body?.data)) {
    return body.data;
  }

  if (Array.isArray(body)) {
    return body;
  }

  return null;
}

export function extractV2PromotionItem(response) {
  if (!response || response.status !== 200) {
    return null;
  }

  const body = response.data;

  if (body?.data && typeof body.data === "object" && !Array.isArray(body.data)) {
    return body.data;
  }

  if (body && typeof body === "object" && "id" in body) {
    return body;
  }

  return null;
}

export function resolvePromotionIdFromSlug(slug) {
  if (/^\d+$/.test(slug)) {
    return Number(slug);
  }

  const match = String(slug).match(/^promotion-(\d+)$/);
  return match ? Number(match[1]) : null;
}
